import { Injectable } from '@angular/core';
import { FnLocalStorageService, FnMenuItemState } from 'foundation';
import { RouterServiceService } from './router-service.service';
import { PosAppService } from './pos.app.service';

@Injectable({
  providedIn: 'root'
})
export class PosLoginResponseService extends FnLocalStorageService {

  isEnableOnUI = true;
  labelHash!: Map<string, string>;
  isDisabled = false;
  menuDataHash!: FnMenuItemState;
  username!: string;
  isBlankResp = true;
  authToken = '';
  //userRole: string = '';
  allowedMenuItems: string[] = [];
  //finalArray: string[] = [];



  constructor(private routerService: RouterServiceService) {
    super();
  }
  setLoginResponse(data: any) {
    // this.username = data.user.username;
    //this.authToken = data['token '];
    this.labelHash = data.labelHash;
    this.menuDataHash = data.menuDataHash.menuData;
    //this.userRole = data.menuDataHash.menuData.id;  // Menu_app_viewerLogin
    this.allowedMenuItems = data.menuDataHash.menuData.menuItemIDArray;  // ["Menu_JPQL", "Menu_TestingDemo"]
    this.isBlankResp = false;
    if (data.menuDataHash.menuData.menuItemArray.length != 0) {
      data.menuDataHash.menuData.menuItemArray.forEach((data: { menuItemIDArray: any }) => {
        if (data.menuItemIDArray.length != 0 || data.menuItemIDArray != 'undefined') {
          data.menuItemIDArray.forEach((data: any) => {

            this.allowedMenuItems.push(data);
          
          })
          this.routerService.setData(this.allowedMenuItems);
        }
      });
    }

  }
  //  // Get the user's role
  //  getUserRole(): string {
  //   return this.userRole;
  // }

  // Check if the user has access to a specific menu item
  hasAccessTo(menuItemID: string): boolean {
    return this.allowedMenuItems.includes(menuItemID);
  }


}
